import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left-icon" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "joy-panel",
    style: _normalizeStyle({top: _ctx.pos + 'px'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_VJoyIcon, { name: "star" })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('customer.brief.form.mission.title.tooltip.title')), 1),
      _createElementVNode("p", {
        innerHTML: _ctx.$msg('customer.brief.form.mission.title.tooltip.content')
      }, null, 8, _hoisted_3)
    ])
  ], 4))
}